module.exports = __webpack_public_path__ + "static/media/Non_Food_BG.96aa2706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/nonfood-store/Non_Food_BG.png
// module id = 490
// module chunks = 0